import React, { memo } from 'react';
import { useRouter } from 'next/router';
import { Home } from 'lucide-react';

import { BreadcrumbListItem } from './components/breadcrumb-list-item';
import { IBreadcrumbs } from '@mais-retorno-front/models/breadcrumbs.model';

import { BreadcrumbContainer, BreadcrumbList } from './styles';

interface BreadcrumbProps {
  breadcrumbs: IBreadcrumbs[];
}

export const Breadcrumbs = memo(({ breadcrumbs }: BreadcrumbProps) => {
  const router = useRouter();

  return (
    <BreadcrumbContainer>
      <BreadcrumbList itemScope itemType="http://schema.org/BreadcrumbList">
        <BreadcrumbListItem
          position={1}
          url="/"
          label="Home"
          icon={<Home width={15} height={15} />}
        />

        {breadcrumbs.map((item, index) => (
          <BreadcrumbListItem
            lastItem={index === breadcrumbs.length - 1}
            position={index + 2}
            url={item.url || router.asPath}
            label={item.label}
            key={`breadcrumb-${item.url}`}
          />
        ))}
      </BreadcrumbList>
    </BreadcrumbContainer>
  );
});
